const mEditionBillingPaymentMethodsConnectMethod = {
  mEditionBillingPaymentMethodsConnectMethod: {
    alerts: {
      createAcademiaPasarela: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El medio de pago fue conectado exitosamente.'
      }
    },

    buttonPrimary: 'CONECTAR',

    inputs: {
      descripcion: {
        label: 'Descripción',
        placeholder: 'Mi Medio de Pago'
      }
    },

    redirect: 'Espera un momento, serás redireccionado...',
    title: 'Completa tus datos de',

    validation: {
      required: 'Información requerida.'
    }
  }
}

export default mEditionBillingPaymentMethodsConnectMethod
